import React from "react";
import { Link } from "react-router-dom";
import { FiArrowRight, FiCheckCircle } from "react-icons/fi";
import "./AllProducts.css";
import judoGi from '../assets/products/judu-gi.jpeg';
import judoGi1 from '../assets/products/judu-gi1.jpeg';
import mma1 from '../assets/products/mma-shorts/mma-shorts.jpeg';
import rash2 from '../assets/products/rash-guards/rash-guard2.jpeg';
import spats1 from '../assets/products/spats/spats1.jpeg';
import sportsBra1 from '../assets/products/sports-bra/sports-bra1.jpeg';
import belt1 from '../assets/products/belts/belt1.jpeg';
import patch1 from '../assets/products/patches/patch1.jpeg';
import hoodie5 from '../assets/products/sports-hoodies/sports-hoodies5.jpeg';

const ALL_CATS = [
  {
    id: "uniforms",
    title: "Uniforms",
    type: "parent",
    tag: "Gis & Kimono",
    color: "#c9a227",
    img: judoGi,
    desc: "Judo Gi, Jiujitsu Gi — competition & training options.",
    sub: [
      {
        title: "Judo Gi",
        path: "/uniforms/judo-gi",
        img: judoGi,
        tag: "IJF Style",
        count: 3,
      },
      {
        title: "Jiujitsu Gi",
        path: "/uniforms/jiujitsu-gi",
        img: judoGi1,
        tag: "Bestseller",
        count: 6,
      },
    ],
  },
  {
    id: 'belts',
    title: 'Belts',
    type: 'direct',
    tag: 'All Ranks',
    color: '#c9a227',
    count: 1,
    path: '/products/belts',   
    img: belt1,
    desc: 'Judo & BJJ belts in all rank colors. Standard & 350 GSM options.',
  },
  {
    id: "mma-shorts",
    title: "MMA Shorts",
    type: "direct",
    tag: "Fight Ready",
    color: "#5b9bd5",
    count: 2,
    path: "/products/mma-shorts",
    img: mma1,
    desc: "Satin & stretch MMA shorts with full sublimation printing.",
  },
  {
    id: 'rash-guards',
    title: 'Rash Guards',
    type: 'direct',
    tag: 'Full & Short Sleeve',
    color: '#9b59b6',
    count: 4, // 4 variants
    path: '/products/rash-guards',
    img: rash2,
    desc: 'IBJJF-legal full & short sleeve rash guards with custom sublimation.'
  },
  {
    id: "spats",
    title: "Spats",
    type: "direct",
    tag: "4-Way Stretch",
    color: "#c9a227",
    count: 2,
    path: "/products/spats",
    img: spats1,
    desc: "Full & 3/4 length grappling spats with custom sublimation.",
  },
  {
    id: "sports-bra",
    title: "Sports Bra",
    type: "direct",
    tag: "Women's",
    color: "#e07b5c",
    count: 2,
    path: "/products/sports-bra",
    img: sportsBra1,
    desc: "High-support sports bras for martial arts & fitness.",
  },
  {
    id: "sports-hoodies",
    title: "Sports Hoodies",
    type: "direct",
    tag: "Custom & Full Sublimation",
    color: "#4caf7d",
    count: 2,
    path: "/products/sports-hoodies",
    img: hoodie5,
    desc: "Custom sports hoodies with full sublimation printing.",
  },
  {
    id: "patches",
    title: "Separate Patches",
    type: "direct",
    tag: "Embroidered+",
    color: "#c9a227",
    count: 4,
    path: "/products/patches",
    img: patch1,
    desc: "Embroidered, woven, sublimation & PVC patches.",
  },
];

export default function AllProducts() {
  return (
    <div className="all-products">
      <section className="ap-hero">
        <div className="ap-hero__bg" />
        <div className="ap-hero__overlay" />
        <div className="container ap-hero__content">
          <span className="section-label">Complete Catalogue</span>
          <h1 className="ap-hero__title">All Products</h1>
          <p className="ap-hero__sub">
            Browse our complete range — competition Gis to MMA gear, belts and
            accessories. Every product is fully customizable.
          </p>
          <div className="ap-hero__pills">
            {["Full OEM Available", "Worldwide", "MOQ from 10 pcs"].map((p) => (
              <span key={p} className="ap-pill">
                <FiCheckCircle size={13} />
                {p}
              </span>
            ))}
          </div>
        </div>
      </section>

      <section className="ap-section">
        <div className="container">
          <div className="ap-intro">
            <span className="section-label">Browse by Category</span>
            <h2 className="section-title">Select a Category</h2>
            <div className="divider-gold" />
            <p className="section-subtitle">
              Categories with sub-types show sub-cards below — click any to view
              products.
            </p>
          </div>

          <div className="ap-grid">
            {ALL_CATS.map((cat) =>
              cat.type === "parent" ? (
                <div key={cat.id} className="ap-parent-card">
                  <div className="ap-parent-card__head">
                    <div className="ap-parent-card__img">
                      <img
                        src={cat.img}
                        alt={cat.title}
                        loading="lazy"
                        onError={(e) => {
                          e.target.style.display = "none";
                        }}
                      />
                      <div className="ap-parent-card__img-overlay" />
                    </div>
                    <div className="ap-parent-card__info">
                      <span
                        className="ap-parent-card__tag"
                        style={{ background: cat.color }}
                      >
                        {cat.tag}
                      </span>
                      <h3 className="ap-parent-card__title">{cat.title}</h3>
                      <p className="ap-parent-card__desc">{cat.desc}</p>
                    </div>
                  </div>
                  <div className="ap-parent-card__subs">
                    <p className="ap-parent-card__subs-label">Choose a Type:</p>
                    <div className="ap-sub-cards">
                      {cat.sub.map((s) => (
                        <Link key={s.path} to={s.path} className="ap-sub-card">
                          <div className="ap-sub-card__img">
                            <img
                              src={s.img}
                              alt={s.title}
                              loading="lazy"
                              onError={(e) => {
                                e.target.style.display = "none";
                              }}
                            />
                          </div>
                          <div className="ap-sub-card__body">
                            <span className="ap-sub-card__tag">{s.tag}</span>
                            <h4 className="ap-sub-card__title">{s.title}</h4>
                            <span className="ap-sub-card__count">
                              {s.count} products
                            </span>
                            <div
                              className="ap-sub-card__cta"
                              style={{ color: cat.color }}
                            >
                              View <FiArrowRight size={13} />
                            </div>
                          </div>
                        </Link>
                      ))}
                    </div>
                  </div>
                </div>
              ) : (
                <Link key={cat.id} to={cat.path} className="ap-direct-card">
                  <div className="ap-direct-card__img">
                    <img
                      src={cat.img}
                      alt={cat.title}
                      loading="lazy"
                      onError={(e) => {
                        e.target.style.display = "none";
                      }}
                    />
                    <div className="ap-direct-card__img-overlay" />
                    <span className="ap-direct-card__count">
                      {cat.count} products
                    </span>
                  </div>
                  <div className="ap-direct-card__body">
                    <span
                      className="ap-direct-card__tag"
                      style={{ background: cat.color }}
                    >
                      {cat.tag}
                    </span>
                    <h3 className="ap-direct-card__title">{cat.title}</h3>
                    <p className="ap-direct-card__desc">{cat.desc}</p>
                    <div
                      className="ap-direct-card__cta"
                      style={{ color: cat.color }}
                    >
                      View Products <FiArrowRight size={14} />
                    </div>
                  </div>
                </Link>
              ),
            )}
          </div>
        </div>
      </section>

      <section className="ap-cta">
        <div className="container ap-cta__inner">
          <div>
            <h2>Can't Find What You Need?</h2>
            <p>
              We manufacture custom products — describe your requirement and
              we'll make it.
            </p>
          </div>
          <Link to="/contact" className="btn-primary">
            Request Custom Quote <FiArrowRight size={16} />
          </Link>
        </div>
      </section>
    </div>
  );
}
